<app-classe-profit [disabled]="disabled" [uid]="getUid()" [parentForm]="parentForm" [classeProfit]="libelle?.classeProfit"></app-classe-profit>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.siret"
[label]="step9.getsiret"
[type]="'text'"
[disabled]="disabled"
[rule]="'pattern_20|required'"
[errorMessage]="{'pattern' : 'ctr_1216','required' : 'ctr_1211_HorsDef'}"
[name]="getUid()+'_SepAtt_siret'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>


<app-form-input
[parentForm]="parentForm"
[value]="libelle?.denomination"

[label]="step9.getdenomination"
[type]="'text'"
[disabled]="disabled"
     [rule]="'minSize_1|maxSize_38|required'"
[name]="getUid()+'_SepAtt_denomination'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.adr1"

[label]="step9.getadr1"
[type]="'text'"
[disabled]="disabled"
     [rule]="'minSize_1|maxSize_38'"
[name]="getUid()+'_SepAtt_adr1'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.adr2"

[label]="step9.getadr2"
[type]="'text'"
[disabled]="disabled"
     [rule]="'minSize_1|maxSize_38'"
[name]="getUid()+'_SepAtt_adr2'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.adr3"

[label]="step9.getadr3"
[type]="'text'"
[disabled]="disabled"
[rule]="'minSize_1|maxSize_38|required'"
[errorMessage]="{'required' : 'ctr_9103'}"
[name]="getUid()+'_SepAtt_adr3'">
</app-form-input>

<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.adr4"

[label]="step9.getadr4"
[type]="'text'"
[disabled]="disabled"
     [rule]="'minSize_1|maxSize_38'"
[name]="getUid()+'_SepAtt_adr4'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.cp"

[label]="step9.getcp"
[type]="'text'"
[disabled]="disabled"
     [rule]="'pattern_3|required'"
[errorMessage]="{'pattern' : 'ctr_43'}"
[name]="getUid()+'_SepAtt_cp'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.ville"

[label]="step9.getlocalite"
[type]="'text'"
[disabled]="disabled"
     [rule]="'minSize_1|maxSize_32|required'"
[name]="getUid()+'_SepAtt_ville'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.pays"

[label]="step9.getpays"
[type]="'select'"
[typeSelect]="optionsSelectType"
 [optionsWithCode]="optionsSelect"
[disabled]="disabled"
[rule]="'pattern_25'"
[errorMessage]="{'pattern' : 'ctr_48'}"
[name]="getUid()+'_SepAtt_pays'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="libelle?.tvaIntracommunautaire"

[label]="step9.gettvaIntracommunautaire"
[type]="'text'"
[disabled]="disabled"
     [rule]="'minSize_2|maxSize_50'"
     [errorMessage]="{'minLength' : 'ctr_tvaIntracommunautaire', 'maxLength' : 'ctr_tvaIntracommunautaire'}"
[name]="getUid()+'_SepAtt_tvaIntracommunautaire'">
</app-form-input>
